import { Blockquote as OriginalBlockquote } from "@tiptap/extension-blockquote";

export const Blockquote = OriginalBlockquote.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class:
          "flex-1 pl-5 relative before:content-[''] before:bg-document-text before:w-0.3 before:rounded-full before:absolute before:left-0 before:top-0 before:h-full",
      },
    };
  },
});
